import {TransactionType, TransactionResponseDto} from "@/api/paymentApi";

export function isNegativeAmountType(transactionType: TransactionType): boolean {
    return [
        TransactionType.PAYMENTRETURN,
        TransactionType.REFUND,
        TransactionType.PAYMENTREVERSAL,
        TransactionType.CHARGEBACKDEBIT,
        TransactionType.CHARGEBACKFEE,
        TransactionType.RESERVEADJUSTMENTDEBIT,
        TransactionType.INVOICEPAYMENT].includes(transactionType);
} 

export function getTransactionTypeDisplayName(transactionType: TransactionType): string {
    switch (transactionType) {
        case TransactionType.REFUND:
          return 'Refund';
        case TransactionType.PAYMENTRETURN:
            return 'Payment Return';
        case TransactionType.PAYMENTREVERSAL:
            return 'Payment Reversal';
        case TransactionType.CHARGEBACKDEBIT:
        case TransactionType.CHARGEBACKFEE:
        case TransactionType.RESERVEADJUSTMENTDEBIT:
        case TransactionType.INVOICEPAYMENT:
            return "Debit";
        case TransactionType.CHARGEBACKCREDIT:
        case TransactionType.RESERVEADJUSTMENTCREDIT:
            return 'Credit';
        case TransactionType.RESERVE:
            return 'Reserve Top Up';
        case TransactionType.RESERVETRANSFER:
        case TransactionType.RESERVEREALLOCATION:
            return 'Reserve Transfer';
        default:
          return 'Payment';
      }
}

export function isPaymentReturnTransaction(transaction: TransactionResponseDto): boolean {
    if (transaction.type === TransactionType.PAYMENTRETURN) {
        return true;
    }
    if (transaction.type === TransactionType.CHARGEBACKFEE) {
        return transaction.tags?.dispute_id === null || transaction.tags?.dispute_id === undefined;
    }
    return false;
}

export function isChargebackTransaction(transaction: TransactionResponseDto): boolean {
    if ([TransactionType.CHARGEBACKDEBIT, TransactionType.CHARGEBACKCREDIT].includes(transaction.type as TransactionType)) {
        return true;
    }
    if (transaction.type === TransactionType.CHARGEBACKFEE) {
        return transaction.tags?.dispute_id !== null && transaction.tags?.dispute_id !== undefined;
    }
    return false;
}